import { handleActions } from 'redux-actions';
import * as addVehicleActions from '../actions/addVehicleActions';

const initState = {
  Status: null,
  Error: null,
};

export const addingVehicleStatus = handleActions(
  {
    [addVehicleActions.addVehicle]: (state, _action) => {
      return { ...state, Status: 'loading' };
    },
    [addVehicleActions.addVehicleSuccess]: (state, _action) => {
      return { ...state, Status: 'success' };
    },
    [addVehicleActions.addVehicleError]: (state, action) => {
      let { payload } = action;
      console.log('addVehicleError Error', payload.message);
      return { Status: 'error', Error: payload.message };
    },
  },
  initState
);
